<template>
  <div class="set-data-container">
    <div class="components">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>

export default {
  name: 'setUserData'
}
</script>

<style lang="scss">
@import "@/assets/scss/constant.scss";
.set-data-container {
  .components {
    text-align: center;
  }
  .cautious {
    color: #CACACA;
    font-size: 32px;
    line-height: 44px;
    text-align: center;
  }
  .who {
    margin-bottom: 70px;
    color: #9b9b9b;
    font-size: 42px;
    line-height: 60px;
  }
  .content-btn {
    display: block;
    padding: 23px;
    color: $mainColor;
    font-size: 36px;
    line-height: 50px;
    border-radius: 50px;
    border: 1px solid $mainColor;
    text-align: center;
    background: #fff;
    & + .content-btn {
      margin-top: 30px;
    }
    &.selected {
      padding: 25px;
      color: #fff;
      border: none;
      background:linear-gradient(305deg, $mainColor 0%,#FFBBD8 100%);
    }
  }
  .van-picker {
    background: transparent;
  }
  .van-picker__toolbar {
    display: none;
  }
  .van-picker-column {
    margin: 0 22px;
    border-top: 1px solid #979797;
    border-bottom: 1px solid #979797;
  }
  .set-sexy {
    padding-top: 180px;
    background: url(~@/assets/img/select-sexy.png) no-repeat left top;
    background-size: 260px auto;
    .choose-con {
      display: flex;
      justify-content: space-between;
      margin-bottom: 84px;
      padding: 0 80px;
    }
    .sexy {
      width: 250px;
      height: 250px;
    }
    .male {
      background: url(~@/assets/img/sex.png) left top;
      background-size: 500px;
      background-position: 0 0;
      &.selected {
        background-position: 0 -250px;
      }
    }
    .female {
      background: url(~@/assets/img/sex.png) left top;
      background-size: 500px;
      background-position: -250px 0;
      &.selected {
        background-position: -250px -250px;
      }
    }
  }

  .set-education {
    padding-top: 180px;
    background: url(~@/assets/img/select-education.png) no-repeat left 40px;
    background-size: 270px auto;
    .choose-con {
      margin-bottom: 80px;
      padding: 0 80px;
    }
  }
  .set-birthday {
    padding-top: 180px;
    background: url(~@/assets/img/select-birthday.png) no-repeat left 50px;
    background-size: 250px auto;
    .select-date-tip {
      margin: 20px 0 62px;
      color: #c6c6c6;
    }
    .cautious {
      margin-bottom: 100px;
    }
    .content-btn {
      margin: 0 80px;
    }
  }
  .set-tall {
    padding-top: 160px;
    background: url(~@/assets/img/select-tall.png) no-repeat left 50px;
    background-size: 250px auto;
    .van-picker {
      padding: 0 230px;
    }
    .select-date-tip {
      margin: 20px 0 62px;
      color: #c6c6c6;
    }
    .cautious {
      margin-bottom: 88px;
    }
    .deals {
      margin-bottom: 30px;
      .word {
        display: inline-block;
        vertical-align: middle;
        color: #CACACA;
        font-size: 32px;
        line-height: 44px;
      }
    }
    .deal-link {
      display: inline-block;
      vertical-align: middle;
      color: $mainColor;
      font-size: 32px;
      line-height: 44px;
    }
    .checkbox {
      position: relative;
      display: inline-block;
      vertical-align: middle;
      margin-right: 40px;
      width: 56px;
      height: 56px;
      border-radius: 12px;
      border: 2px solid #9b9b9b;
      .tick {
        position: absolute;
        top: 50%;
        left: 50%;
        display: none;
        width: 32px;
        transform: translate(-50%, -50%);
      }
      &.focus {
        border: 2px solid $mainColor;
      }
      &.checked {
        border: 2px solid $mainColor;
        .tick {
          display: block;
        }
      }
    }
    .content-btn {
      margin: 0 80px;
    }
  }
  .set-phone {
    padding: 80px 80px 20px;
    .title {
      top: 134px;
      height: 90px;
      font-size: 64px;
      font-family: PingFangSC-Regular,PingFang SC;
      font-weight: 400;
      color: rgba(255,63,145,1);
      line-height: 90px;
      text-align: left;
    }
    .notice {
      margin: 40px 0 34px;
      height: 45px;
      font-size: 32px;
      font-family: PingFangSC-Regular,PingFang SC;
      font-weight: 400;
      color: rgba(155,155,155,1);
      line-height: 45px;
      text-align: left;
    }
    .tab {
      position: relative;
      margin-bottom: 40px;
    }
    .tab-con {
      margin-bottom: 8px;
      display: flex;
      flex-flow: row nowrap;
      justify-content: flex-start;
    }
    .tab-item {
      position: relative;
      height: 45px;
      font-size: 32px;
      font-family: PingFangSC-Medium,PingFang SC;
      font-weight: 500;
      color: #9b9b9b;
      line-height: 45px;
      text-align: left;
      &.cur {
        color: rgba(0,0,0,0.85);
        &:before {
          content: '';
          position: absolute;
          bottom: -8px;
          left: 50%;
          width: 70px;
          height: 6px;
          border-radius: 5px;
          background: #262626;
          transform: translate(-50%, 100%);
        }
      }
      & + .tab-item {
        margin-left: 75px;
      }
    }
    .input_phone {
      display: flex;
      align-items: center;
      padding: 20px 0 20px 0;
      height: 100px;
      background: #fff;
      border-radius: 4px;
      border: 1px solid #979797;
      .input {
        flex: 1 1 auto;
        width: 200px;
        padding-left: 24px;
      }
      .btn {
        flex: 0 1 auto;
        margin-right: 28px;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: center;
        padding: 0 20px;
        min-width: 176px;
        height: 60px;
        color: inherit;
        font-size: 28px;
        line-height: 40px;
        background: rgba(243,243,243,1);
        border-radius: 4px;
        border: 1px solid #909090;
      }
      .count {
        font-size: 28px;
        line-height: 40px;
      }
    }
    .input_code {
      margin: 30px 0 24px;
      background: #fff;
      border-radius: 4px;
      border: 1px solid #979797;
      .input {
        padding: 28px;
      }
    }
    .input {
      display: block;
      width: 100%;
      height: 100%;
      font-size: 32px;
    }
    .wrong {
      height: 34px;
      color: #D0021B;
      font-size: 24px;
      line-height: 34px;
      font-weight: 400;
      text-align: left;
    }
    .complet{
      position: fixed;
      bottom: 20px;
      left: 0;
      width: 100%;
      padding: 0 80px;
    }
  }
}
</style>
